import { useQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { mapDeliveryEstimation } from '../mappers/delivery-estimation.js';
import { GET_DELIVERY_ESTIMATION } from '../operations/queries/get-delivery-estimation.js';

const useGetDeliveryEstimationMessage = (items, shippingMethodKey, withRxLens)=>{
    var ref, ref1, ref2, ref3;
    const { dateTime: { formatDate  } , getFormattedLabel , locale ,  } = useIntl();
    const { data , loading , error  } = useQuery(GET_DELIVERY_ESTIMATION, {
        variables: {
            input: {
                skuQuantityPairs: items,
                shippingMethodKey
            }
        }
    });
    const deliveryEstimation = mapDeliveryEstimation(data, locale);
    let deliveryMessage = '';
    if (deliveryEstimation === null || deliveryEstimation === void 0 ? void 0 : deliveryEstimation.deliveryDate) {
        deliveryMessage = getFormattedLabel('products.deliveryIndicator.deliveryIndicationFullDate', {
            labelData: {
                deliveryDate: formatDate(deliveryEstimation.deliveryDate, 'short'),
                deliveryMethod: deliveryEstimation.shippingMethodDescription
            }
        });
    } else if (withRxLens && (deliveryEstimation === null || deliveryEstimation === void 0 ? void 0 : (ref = deliveryEstimation.deliveryRanges) === null || ref === void 0 ? void 0 : ref.minWithPrescription) && (deliveryEstimation === null || deliveryEstimation === void 0 ? void 0 : (ref1 = deliveryEstimation.deliveryRanges) === null || ref1 === void 0 ? void 0 : ref1.maxWithPrescription)) {
        deliveryMessage = getFormattedLabel('products.deliveryIndicator.deliveryIndicationRanges', {
            labelData: {
                deliveryMin: deliveryEstimation.deliveryRanges.minWithPrescription,
                deliveryMax: deliveryEstimation.deliveryRanges.maxWithPrescription,
                deliveryMethod: deliveryEstimation.shippingMethodDescription
            }
        });
    } else if ((deliveryEstimation === null || deliveryEstimation === void 0 ? void 0 : (ref2 = deliveryEstimation.deliveryRanges) === null || ref2 === void 0 ? void 0 : ref2.min) && (deliveryEstimation === null || deliveryEstimation === void 0 ? void 0 : (ref3 = deliveryEstimation.deliveryRanges) === null || ref3 === void 0 ? void 0 : ref3.max)) {
        deliveryMessage = getFormattedLabel('products.deliveryIndicator.deliveryIndicationRanges', {
            labelData: {
                deliveryMin: deliveryEstimation.deliveryRanges.min,
                deliveryMax: deliveryEstimation.deliveryRanges.max,
                deliveryMethod: deliveryEstimation.shippingMethodDescription
            }
        });
    }
    if (error) {
        console.error(error);
    }
    return {
        deliveryMessage,
        loading,
        error
    };
};

export { useGetDeliveryEstimationMessage };
//# sourceMappingURL=use-get-delivery-estimation-message.js.map
